module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workbench-app"
  }, [_c('div', {
    staticClass: "workbench-app__main-container"
  }, [_c('div', {
    staticClass: "workbench-app__attribute-panel"
  }, [_c('attribute-panel', {
    staticClass: "workbench-app__main-container__side-panel",
    attrs: {
      "setOfAttributes": _vm.attributes,
      "onSelect": _vm.selectAttribute,
      "workbenchHeaderData": _vm.copiedTarget,
      "selectedValues": _vm.selectedXandrAttributes,
      "canEditTargetHeaderData": _vm.canEditTargetHeaderData,
      "datasetFilter": _vm.datasetFilter,
      "viewOnly": _vm.viewOnly
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "workbench-app__main-container__slotted"
  }, [_vm._t("main-container", null, {
    "slottedValue": _vm.workbenchSlottedValue
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "workbench-app__bottom-pane"
  }, [_vm._t("bottom-pane", null, {
    "copiedTarget": _vm.copiedTarget
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f8b3c2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/WorkbenchCanvas.vue
// module id = 1893
// module chunks = 0